<div class="row">
  <div style="min-width: 250px" class="col"><app-images-box (onChange)="onChange($event, 0)" [title]="'תמונה ראשית'"></app-images-box></div>
  <div style="min-width: 250px" class="col"><app-images-box (onChange)="onChange($event, 1)" [title]="'תמונה 1'"></app-images-box></div>
</div>
<div class="row">
  <div style="min-width: 250px" class="col"><app-images-box (onChange)="onChange($event, 2)" [title]="'תמונה 2'"></app-images-box></div>
  <div style="min-width: 250px" class="col"><app-images-box (onChange)="onChange($event, 3)" [title]="'תמונה 3'"></app-images-box></div>
  <div style="min-width: 250px" class="col"><app-images-box (onChange)="onChange($event, 4)" [title]="'תמונה 4'"></app-images-box></div>
</div>
